export enum DashboardOutstandingByMonthPivotMode {
    Committed = 'Committed',
    Funded = 'Funded',
    Number = 'Number',
}
